import { isEditable, isDialogOpen } from '@/utils/keyboard';

// Every list filter renders its search box as type="search"; a hidden one
// cannot take focus, so it never matches.
const findSearchField = () => [...document.querySelectorAll('.v-main input[type="search"]')]
  .find((input) => input.offsetParent !== null);

export const onSearchShortcut = (event) => {
  if (event.key !== '/' || event.ctrlKey || event.altKey || event.metaKey) return;
  if (isEditable(event.target) || isDialogOpen()) return;

  const field = findSearchField();
  if (!field) return;

  event.preventDefault();
  field.focus();
};

export const registerSearchShortcut = () => {
  document.addEventListener('keydown', onSearchShortcut);
};
